import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';

import { SetCurrentCodeSection, SetCurrentCodePage } from '../shared/navigation.state';

@Component({
  selector: 'app-emmenagement',
  templateUrl: './emmenagement.component.html',
  styleUrls: ['./emmenagement.component.scss'],
  standalone: false
})
export class EmmenagementComponent implements OnInit {
  constructor(private readonly _store: Store) {}

  ngOnInit() {
    this._store.dispatch(new SetCurrentCodeSection('EMNGMNT'));
    this._store.dispatch(new SetCurrentCodePage('emmenagement'));
  }

  getBackgroundImageSource() {
    return {
      desktop: '/sub-footer/desktop-fond-de-maison-avec-plaines.svg',
      mobile: '/sub-footer/desktop-fond-de-maison-avec-plaines-2x.svg'
    };
  }
}
